































import { SpotWidgetDataMixin } from '@/features/core/components/spot-widget-control/data-mixin';
import { ContinuousMetricPoint } from '@/features/core/util/metrics';
import { range } from 'lodash';
import { Component, Mixins } from 'vue-property-decorator';
import bgImage from './dual-temperature-lg.svg';

interface TemperatureMetric {
  index: number;
  name: string;
  point?: ContinuousMetricPoint;
  serial?: string;
  position: number;
}

@Component
export default class DualTemperatureDevicePanel extends Mixins(SpotWidgetDataMixin) {
  private get temperatureMetrics(): TemperatureMetric[] {
    return range(1, 3)
      .map((index) => ({
        index,
        name: `temperature${index}`,
        point: this.metrics.continuous[`temperature${index}`],
        serial: this.metrics.discrete[`externalProbeSerialNumber${index}`]?.value,
        position:
          this.spot?.metricConfigurations.find(({ name }) => name === `temperature${index}`)?.position ??
          Number.MAX_VALUE,
      }))
      .sort((a, b) => a.position - b.position || a.index - b.index);
  }

  private backgroundImage = bgImage;
}
